// services/opcionesProductoService.js
import apiClient from './api';
import { API_CONFIG } from '../utils/constants';

const BASE = API_CONFIG.ENDPOINTS.OPCIONES_PRODUCTO;

export const OpcionesProductoService = {

  // ── GRUPOS ──────────────────────────────────────────────────────────────────

  async getGruposByProducto(idProducto) {
    const res = await apiClient.get(`${BASE}/grupos/producto/${idProducto}`);
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? []);
  },

  async createGrupo(body) {
    const res = await apiClient.post(`${BASE}/grupos`, body);
    return res.data?.data ?? res.data;
  },

  async updateGrupo(idGrupo, body) {
    const res = await apiClient.put(`${BASE}/grupos/${idGrupo}`, body);
    return res.data?.data ?? res.data;
  },

  async deleteGrupo(idGrupo) {
    await apiClient.delete(`${BASE}/grupos/${idGrupo}`);
  },

  // ── OPCIONES ────────────────────────────────────────────────────────────────

  async getOpcionesByGrupo(idGrupo) {
    const res = await apiClient.get(`${BASE}/opciones/grupo/${idGrupo}`);
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? []);
  },

  async createOpcion(formData) {
    const res = await apiClient.post(`${BASE}/opciones`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data?.data ?? res.data;
  },

  async updateOpcion(idOpcion, formData) {
    const res = await apiClient.put(`${BASE}/opciones/${idOpcion}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data?.data ?? res.data;
  },

  async deleteOpcion(idOpcion) {
    await apiClient.delete(`${BASE}/opciones/${idOpcion}`);
  },

  async toggleDisponibilidad(idOpcion) {
    const res = await apiClient.patch(`${BASE}/opciones/${idOpcion}/toggle`);
    return res.data?.data ?? res.data;
  },
};